import * as RouterDOM from 'react-router-dom'

import type { AppNode } from './TypedNode'
import type { AppModel } from './ViewModel'
import type { VC } from '@rehaje/react'

export const AppComponent: VC<AppNode, AppModel> = ({ model, node }) => {
  if (!model) return null
  return (
    <RouterDOM.RouterProvider
      fallbackElement={node.plugin.props.spinnerElement}
      router={model.router as any}
    />
  )
}
